// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Gxiqz","content":"Consent_content__2Ze1T","footer":"Consent_footer__3fisY"};